import type { PendingCartProduct } from '@jane/shared/types';

/**
 * @returns true if any cart product has a special/deal
 */
export const hasSpecial = (products: PendingCartProduct[]) => {
  return products.some(({ special_id }) => !!special_id);
};
